import KendoChartMixinBase from './KendoChartMixinBase'

export default {
    name: 'kendo-chart',
    mixins: [ KendoChartMixinBase ]
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/index.js